export type MobileWorkspace = 'coach' | 'trainer';

const TRAINER_PATH_PREFIXES = [
  '/trainer-dugout',
  '/training-practices',
  '/training-sessions',
  '/training-exercise-plans',
  '/training-calendar',
  '/plans/',
];

export const isTrainerPath = (pathname: string): boolean =>
  TRAINER_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

export const resolveMobileWorkspace = (params: {
  pathname: string;
  isTrainer: boolean;
  canAccessCoachTools: boolean;
  hasManagementRole: boolean;
}): MobileWorkspace => {
  if (!params.isTrainer) return 'coach';
  if (isTrainerPath(params.pathname)) return 'trainer';
  if (!params.canAccessCoachTools && !params.hasManagementRole) return 'trainer';
  return 'coach';
};

export const getTrainerOnlyHome = (params: {
  isTrainer: boolean;
  canAccessCoachTools: boolean;
  hasManagementRole: boolean;
}): '/trainer-dugout' | null =>
  params.isTrainer && !params.canAccessCoachTools && !params.hasManagementRole
    ? '/trainer-dugout'
    : null;
